import React from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import BranchGroupsActions from "./widget/BranchGroupsActions";
import BranchGroupsContent from "./BranchGroupsContent";
import { HomeContextProvider } from "../../../provider/home/HomeContextProvider";
import { BranchGroupsContextProvider } from "../../../provider/branch/branch_groups/BranchGroupsContextProvider";

const BranchGroupsScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <HomeContextProvider>
      <BranchGroupsContextProvider>
        <Scaffold
          appBarTitle={AppTranslation.text("groups")}
          appBarAction={<BranchGroupsActions />}
        >
          <MainBodyContainer>
            <BranchGroupsContent type={type} isModal={false} />
          </MainBodyContainer>
        </Scaffold>
      </BranchGroupsContextProvider>
    </HomeContextProvider>
  );
};

export default BranchGroupsScreen;
export const routeName: string = "/branch-groups";
